<template>
    <div>
        <h5 class="grey-color fw-600">Измените спецификацию</h5>
        <fl44-contract-supplementary-agreement-termination-specifications-edit-table v-model="form.deliverables" :v="$v.form.deliverables" :is-loading="isLoading" />
        <b-form-invalid-feedback :state="!$v.form.deliverables.$invalid" class="my-2" style="padding-left: 5px; padding-right: 5px" v-if="$v.form.deliverables.$invalid">{{ specErrorMessage }}</b-form-invalid-feedback>
        <text-row-price :label-cols-lg="4" label="Общая стоимость, руб." :value="specSum" />
        <text-row-price :label-cols-lg="4" label="Общая стоимость контракта, руб." :value="pivc.purchaseitem.contract.price_total" />
        <form-row-edit-date :label-cols-lg="4" label="Дата заключения дополнительного соглашения" v-model="form.supplementary_agreement_date" :v="$v.form.supplementary_agreement_date" :min-date="purchase.contract_date" :max-date="$now()" compact />
        <form-row-single-line-document-upload v-model="form.supplementary_agreement_attachment" :label-cols-lg="4" :v="$v.form.supplementary_agreement_attachment" title="Дополнительное соглашение" compact />

        <b-button variant="custom-outline-secondary" class="text-uppercase mt-2" @click="onCancel">Отмена</b-button>
        <b-button variant="custom-green" class="text-uppercase mt-2 ml-2" :disabled="$v.$invalid" @click="createSupplementaryAgreement">Отправить дополнительное соглашение поставщику</b-button>
        <p class="font-weight-bold text-danger mt-3 mb-1 fs-14">Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса.</p>
    </div>
</template>

<script>
import { minLength, minValue, required } from 'vuelidate/lib/validators';
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';
import Fl44ContractSupplementaryAgreementTerminationSpecificationsEditTable from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-specifications-edit-table.vue';
import Config from '@core/js/ddriven/application/config/Config';

export default {
    name: 'fl44-contract-supplementary-agreement-termination-create-agreement-of-parties-block',
    components: {
        Fl44ContractSupplementaryAgreementTerminationSpecificationsEditTable
    },
    props: {
        purchase: {
            type: Object
        },
        pivc: {
            type: Object
        },
        terminationType: {
            type: String
        }
    },
    data() {
        return {
            isLoading: false,
            price: null,
            priceLimit: null,
            form: {
                supplementary_agreement_date: null,
                supplementary_agreement_attachment: null,
                type: 'termination',
                deliverables: []
            }
        };
    },
    validations() {
        return {
            form: {
                supplementary_agreement_date: {
                    required
                },
                supplementary_agreement_attachment: {
                    required
                },
                deliverables: {
                    required,
                    minLength: minLength(1),
                    priceLimit() {
                        return this.specSum <= this.priceLimit;
                    },
                    $each: {
                        ktru_item_id: { required },
                        amount: { required, minValue: minValue(0) },
                        minAmount(item) {
                            return item.amount >= item.min_amount;
                        },
                        maxAmount(item) {
                            return item.amount <= item.max_amount;
                        },
                        price: {
                            required,
                            minValue: minValue(0.01)
                        },
                        maxPrice(item) {
                            return item.price <= item.max_price;
                        }
                    }
                }
            }
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        async fillData() {
            this.isLoading = true;
            await this.$api.personal.fl44
                .getSupplementaryAgreementTerminationTemplateData(this.purchase.id)
                .then((response) => {
                    this.form.deliverables = response.deliverables;
                    this.contract_conclusion_date = response.contract_conclusion_date;
                    this.price = response.price;
                    this.priceLimit = response.max_price;
                })
                .catch(() => {
                    this.$emit('cancel');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async createSupplementaryAgreement() {
            this.isLoading = true;
            const formData = {
                ...this.form,
                termination_type: this.terminationType
            };
            await this.$api.personal.fl44
                .sendSupplementaryAgreementToSupplier(this.purchase.id, formData)
                .then(() => {
                    this.$emit('done');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        limitsValidate(value) {
            this.isLimitsValid = !value;
        }
    },
    computed: {
        Config() {
            return Config;
        },
        features() {
            return Config.get('theme.features');
        },
        specSum() {
            return roundToTwoDecimals(
                this.form.deliverables.reduce((sum, item) => {
                    return (sum += roundToTwoDecimals(item.amount * item.price));
                }, 0)
            );
        },
        specErrorMessage() {
            const deliverables = Object.values(this.$v.form.deliverables.$each.$iter);
            if (deliverables.some((e) => e.amount.$invalid)) return 'У одной или более позиций в таблице спецификации не заполнено поле "Количество фактическое"';
            if (!this.$v.form.deliverables.priceLimit) return `Сумма по ДС о расторжении не должна превышать сумму контракта / ДС (${this.$formatPrice(this.priceLimit)} руб.)`;
            return '';
        }
    }
};
</script>
